import React from "react";
import MyCV from "../../assets/MyCV.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={MyCV} download className="btn">
        Download CV
      </a>
      <a href="#contact-me" id="contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
